import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from "src/environments/environment";
import { IDataTerritories } from '../Models/IDataTerritories';
import { TerritoriesListItem } from '../Models/TerritoriesListItem';
import { TerritoriesService } from './TerritoriesService.service';
import { TerritoriesLayerControlService } from './TerritoriesLayerControl.service';
import { TerritoryRouteTypeEnum } from '../utilities/enums/TerritoriesEnum';
@Injectable({
  providedIn: 'root'
})
export class PanelDetailTerritoriesService {
  

  private territoryItem : TerritoriesListItem = null;
  private isStandAlone: boolean = false;
  isVisibleDetails$: Subject<boolean> = new Subject<boolean>();
  
  private isLoading$: Subject<boolean> = new Subject();

  constructor(private territoriesService: TerritoriesService, private territoriesLayerService: TerritoriesLayerControlService) {
    
  }
  setLoading(resp) {
    this.isLoading$.next(resp);
  }

  getLoading() {
    return this.isLoading$.asObservable();
  }

  setData(territoryItem: TerritoriesListItem, isStandAlone: boolean) {
    this.territoryItem = territoryItem;
    this.isStandAlone = isStandAlone;
  }

  getData(): {territoryItem: TerritoriesListItem, isStandAlone: boolean} {
    return {territoryItem: this.territoryItem, isStandAlone: this.isStandAlone};
  }

  // initializeLayers(){
  //   this.territoriesLayerService.initializeDetailTerritoryLayers();
  // }

  openDetailsPopup(identifier: any, parentCoordX: string, parentCoordY: string){
    this.territoriesLayerService.openLocationPopup(identifier, parentCoordX, parentCoordY, 'detail');
  }

  addActiveTerritoryPolygonFilter(territoryId: string) {
    this.territoriesLayerService.addActiveTerritoryPolygonFilter(territoryId);
  }

  removeActiveTerritoryPolygonFilter(territoryId: string) {
    this.territoriesLayerService.removeActiveTerritoryPolygonFilter(territoryId);
  }

  addActiveTerritoryLocationFilter(territoryIdentifier: string) {
    this.territoriesLayerService.addActiveTerritoryLocationFilter(territoryIdentifier);
  }

  removeActiveTerritoryLocationFilter(territoryIdentifier: string) {
    this.territoriesLayerService.removeActiveTerritoryLocationFilter(territoryIdentifier);
  }

  removeFilters(){
    this.territoriesLayerService.removeFilters();
  }

  loadMorePolygonGeoJson(geoJson: any){
    this.territoriesLayerService.loadMorePolygonGeoJson('all', geoJson);
  }

  loadPolygonGeoJson(geoJson: any){
    this.territoriesLayerService.loadPolygonGeoJson('all', geoJson);
  }

  loadMoreLocationGeoJson(geoJson: any){
    this.territoriesLayerService.loadMoreLocationGeoJson('all', geoJson);
  }

  assignColor(identifier: string){
    return this.territoriesLayerService.assignColor(identifier);
  }

  destroyLayers(){
    this.territoriesLayerService.destroySourceAndLayers();
  }

}
